import { useQuery } from '@tanstack/react-query';
import { EquipmentReservation } from '@models/warehouse.model';
import { warehouseService } from '@services/warehouse';

export const EQUIPMENT_RESERVATIONS_QUERY_KEY = ['equipmentReservations'];

export const useEquipmentReservations = (assetId: string | undefined) => {
  return useQuery<EquipmentReservation[], Error>({
    queryKey: [...EQUIPMENT_RESERVATIONS_QUERY_KEY, assetId],
    queryFn: async () => {
      if (!assetId) throw new Error('assetId is required');
      return warehouseService.getEquipmentReservations(assetId);
    },
    enabled: !!assetId,
    staleTime: 2 * 60 * 1000,
  });
};

export const useEquipmentReservationsByTask = (taskId: string | undefined) => {
  return useQuery<EquipmentReservation[], Error>({
    queryKey: [...EQUIPMENT_RESERVATIONS_QUERY_KEY, 'byTask', taskId],
    queryFn: async () => {
      if (!taskId) throw new Error('taskId is required');
      return warehouseService.getEquipmentReservationsByTask(taskId);
    },
    enabled: !!taskId,
    staleTime: 2 * 60 * 1000,
  });
};
